module.exports = __webpack_public_path__ + "static/img/interior.790b237.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/interior.png
// module id = 1399
// module chunks = 1